import { render } from "./contactComponent.vue?vue&type=template&id=099c49dc&scoped=true"
import script from "./contactComponent.vue?vue&type=script&lang=js"
export * from "./contactComponent.vue?vue&type=script&lang=js"

import "./contactComponent.vue?vue&type=style&index=0&id=099c49dc&scoped=true&lang=css"

import exportComponent from "F:\\work\\rahul\\mangal karyala\\gore-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099c49dc"]])

export default __exports__